import { ActionContext, MutationTree, ActionTree, GetterTree } from 'vuex'
import axios, { AxiosResponse } from 'axios'
import config from '../config'
import moment, { Moment } from 'moment'
import Router from '../router'
import { clearV2Token } from '../webApi'

class AuthState {
  public isInitialized:boolean = false
  public token:string = null
  public tokenExpires:Moment = null
  public refreshToken:string = null
}
const mutations = <MutationTree<AuthState>>{
  setToken (state: AuthState, { token, tokenExpires }:{token:string, tokenExpires:Moment}): void {
    state.token = token
    state.tokenExpires = tokenExpires
  },
  setRefreshToken (state: AuthState, refreshToken:string): void {
    state.refreshToken = refreshToken
  },
  setInitialized (state:AuthState, isInitialized) {
    state.isInitialized = isInitialized
  }
}
const actions = <ActionTree<AuthState, any>> {
  initialize (store:ActionContext<AuthState, any>):void {
    if (store.state.isInitialized) {
      return
    }

    const token = window.localStorage.getItem('id_token')
    const tokenExpires = moment(parseInt(window.localStorage.getItem('id_token_expires')))
    store.commit('setToken', { token, tokenExpires })
    store.commit('setInitialized', true)
  },
  login (store: ActionContext<AuthState, any>, { username, password, redirect }: { username: string, password:string, redirect: string}):Promise<any> {
    window.localStorage.removeItem('id_token')
    return axios.post(config.get_API_URL() + '/Token', 'grant_type=password&username=' + username + '&password=' + encodeURIComponent(password), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then((result:AxiosResponse) => {
      // When login was successful store tokens
      window.localStorage.setItem('id_token', result.data.access_token)
      window.localStorage.setItem('id_token_expires', Date.parse(result.data['.expires']).toString())

      store.commit('setToken', { token: result.data.access_token, tokenExpires: moment(result.data['.expires']) })
      store.commit('setRefreshToken', result.data.refresh_token)

      if (redirect && redirect !== '') {
        // We will redirect the to a new router location
        Router.push(redirect)
      } else {
        // Reload the page
        window.location.reload()
      }
    }).catch(() => {
      window.bus.$emit('openErrorModal', 'There was an problem with your login. Please try again.')
      store.dispatch('logout')
    })
  },
  refreshAccessToken (store: ActionContext<AuthState, any>):Promise<any> {
    const currentRefreshToken = store.state.refreshToken
    if (!currentRefreshToken) {
      return Promise.reject(new Error('No refresh token available'))
    }
    return axios.post(config.get_API_URL() + '/Token/refresh', {
      refresh_token: currentRefreshToken
    }, {
      headers: { 'Content-Type': 'application/json' }
    }).then((result:AxiosResponse) => {
      window.localStorage.setItem('id_token', result.data.access_token)
      window.localStorage.setItem('id_token_expires', Date.parse(result.data['.expires']).toString())
      store.commit('setToken', { token: result.data.access_token, tokenExpires: moment(result.data['.expires']) })
      store.commit('setRefreshToken', result.data.refresh_token)
      return result.data.access_token
    })
  },
  logout (store: ActionContext<AuthState, any>): void {
    clearV2Token()
    var parcelFilters = window.localStorage.getItem('parcelFilters')
    var parcelListColumnSetup = window.localStorage.getItem('parcel_list_column_setup')
    var dashboardColumnSetup = window.localStorage.getItem('dashboard_column_setup')
    window.localStorage.clear()
    window.localStorage.setItem('parcelFilters', parcelFilters)
    window.localStorage.setItem('parcel_list_column_setup', parcelListColumnSetup)
    window.localStorage.setItem('dashboard_column_setup', dashboardColumnSetup)
    window.sessionStorage.clear()
    store.commit('setToken', { token: null, tokenExpires: null })
    store.commit('setRefreshToken', null)
    store.dispatch('reset', null, { root: true })
    if (Router.currentRoute.path !== '/login') {
      Router.push('/login')
    }
  }

}
const getters = <GetterTree<AuthState, any>> {
  isAuthenticated: (state:AuthState):any => ():boolean => {
    if (state.token && state.token.length > 0 && state.tokenExpires && state.tokenExpires.isAfter(moment())) {
      return true
    } else {
      return false
    }
  },
  isAuthMemoized: (state:AuthState):boolean => {
    if (state.token && state.token.length > 0 && state.tokenExpires && state.tokenExpires.isAfter(moment())) {
      return true
    } else {
      return false
    }
  },
  authHeader (state:AuthState):string {
    return 'Bearer ' + state.token
  },
  getRefreshToken (state:AuthState):string {
    return state.refreshToken
  }
}
export default ({
  namespaced: true,
  state: new AuthState(),
  mutations,
  actions,
  getters
})
